/**
 * Note: this is only run once, because we only need to evaluate
 * these parameters when the app starts. This saves code execution time,
 * but the tradeoff is that it does not react to in-app url changes.
 */
const params = new URLSearchParams(window.location.search.substring(1));

/**
 * Returns data from the router-injected configuration
 */
export function routerStrategy (key) {
    return window.teester ? window.teester[key] : null;
}

/**
 * Returns data from the url query parameters
 */
export function queryStrategy (key) {
    return params.get(key);
}

/**
 * Returns data from local storage
 */
export function localStorageStrategy (key) {
    return localStorage.getItem(key);
}

/**
 * Returns data from session storage
 */
export function sessionStorageStrategy (key) {
    return sessionStorage.getItem(key);
}
